import { FC, ReactNode } from 'react';

import Card from 'design-system/components/Card';
import { Paragraph } from 'design-system/components/Text';

interface RelatedObjectCardProps {
  title: ReactNode;
  subTitle: ReactNode;
}

const RelatedObjectCard: FC<RelatedObjectCardProps> = ({
  title,
  subTitle,
  // children comes here to render truncated part
}) => {
  return (
    <Card>
      <Card.Body>
        {/* Having a div to combine title and subTitle as an single element to avoid grid-gap from Card.Body */}
        <div>
          <Paragraph as='h3' color='primary' size='lg'>
            {title}
          </Paragraph>
          {subTitle}
        </div>
      </Card.Body>
    </Card>
  );
};

export default RelatedObjectCard;
